

import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { PayloadCryptoInterceptor } from './core/interceptors/payload-crypto.interceptor';
import { environment } from '../environments/environment';

// DashboardService config provider
const dashboardServiceConfigProvider = {
  provide: 'DASHBOARD_SERVICE_CONFIG',
  useValue: { apiBaseUrl: environment.apiBaseUrl }
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    // Disable the CSS Popover API for all overlays.
    // Angular Material 21 defaults to using the native popover API ("inline" mode),
    // which inserts the overlay inside the origin element. When CSS zoom is applied to
    // an ancestor (#zoom-wrapper), the zoom is inherited by the popover, causing the
    // dropdown panel to appear shifted. Setting usePopover:false restores the classic
    // behaviour (overlays appended to body's cdk-overlay-container) used in Angular 19.
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PayloadCryptoInterceptor, multi: true },
    dashboardServiceConfigProvider,
  ],
};
